namespace GeniuzPOS.LogManage {
    export interface LogUserPasswordChangeDateForm {
        Username: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        PasswordChangeDate: Serenity.DateEditor;
    }

    export class LogUserPasswordChangeDateForm extends Serenity.PrefixedContext {
        static formKey = 'LogManage.LogUserPasswordChangeDate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LogUserPasswordChangeDateForm.init)  {
                LogUserPasswordChangeDateForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(LogUserPasswordChangeDateForm, [
                    'Username', w0,
                    'ShopId', w0,
                    'DisplayName', w0,
                    'Email', w0,
                    'PasswordChangeDate', w1
                ]);
            }
        }
    }
}
